{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Překročili jste limit konverzací. Hacker plán umožňuje pouze 500 konverzací.",
      "INBOXES": "Překročili jste limit schránek. Hacker plán podporuje pouze live-chat na webu. Další schránky jako email, WhatsApp atd. vyžadují placený plán.",
      "AGENTS": "Překročili jste limit agentů. Hacker plán umožňuje pouze 2 agenty.",
      "NON_ADMIN": "Kontaktujte prosím svého administrátora pro upgrade plánu a pokračujte v používání všech funkcí."
    },
    "TITLE": "Nastavení účtu",
    "SUBMIT": "Aktualizovat nastavení",
    "BACK": "Zpět",
    "DISMISS": "Zavřít",
    "UPDATE": {
      "ERROR": "Nelze aktualizovat nastavení, zkuste to znovu!",
      "SUCCESS": "Nastavení účtu bylo úspěšně aktualizováno"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Smazat váš účet",
      "NOTE": "Jakmile smažete svůj účet, budou smazána všechna vaše data.",
      "BUTTON_TEXT": "Smazat váš účet",
      "CONFIRM": {
        "TITLE": "Smazat účet",
        "MESSAGE": "Smazání vašeho účtu je nevratné. Zadejte níže název svého účtu pro potvrzení, že jej chcete trvale smazat.",
        "BUTTON_TEXT": "Smazat",
        "DISMISS": "Zrušit",
        "PLACE_HOLDER": "Pro potvrzení zadejte prosím {accountName}"
      },
      "SUCCESS": "Účet označen ke smazání",
      "FAILURE": "Účet se nepodařilo smazat, zkuste to znovu!",
      "SCHEDULED_DELETION": {
        "TITLE": "Účet je naplánován ke smazání",
        "MESSAGE_MANUAL": "Tento účet je naplánován ke smazání dne {deletionDate}. Tato akce byla vyžádána administrátorem. Smazání můžete zrušit před tímto datem.",
        "MESSAGE_INACTIVITY": "Tento účet je naplánován ke smazání dne {deletionDate} z důvodu neaktivity. Smazání můžete zrušit před tímto datem.",
        "CLEAR_BUTTON": "Zrušit naplánované smazání"
      }
    },
    "FORM": {
      "ERROR": "Opravte chyby formuláře",
      "GENERAL_SECTION": {
        "TITLE": "Obecná nastavení",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID účtu",
        "NOTE": "Toto ID je potřeba, pokud vytváříte integraci založenou na API"
      },
      "NAME": {
        "LABEL": "Název účtu",
        "PLACEHOLDER": "Název vašeho účtu",
        "ERROR": "Zadejte prosím platný název účtu"
      },
      "LANGUAGE": {
        "LABEL": "Jazyk administrace",
        "PLACEHOLDER": "Jazyk v jakém se uživatelům zobrazuje administrace",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Doména příchozích e-mailů",
        "PLACEHOLDER": "Doména, na které přijímáte e-maily",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mail podpory",
        "PLACEHOLDER": "E-mail podpory vaší společnosti",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Počet hodin, po kterých by měla být konverzace automaticky vyřešena při žádné aktivitě",
        "NOTE": "Počet hodin neaktivity, po kterých bude jakákoli otevřená konverzace automaticky označena jako vyřešená.",
        "PLACEHOLDER": "nikdy",
        "ERROR": "Zadejte prosím platnou dobu automatického vyřešení (minimálně 1 hodina a maximálně 23976 hodin)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Počet minut, po kterých by měla být prázdná konverzace automaticky vyřešena při žádné aktivitě",
        "PLACEHOLDER": "nikdy",
        "ERROR": "Zadejte prosím platnou dobu automatického vyřešení prázdných konverzací (minimálně 5 minut a maximálně 1440 minut)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "E-mailová konverzace je u vašeho účtu povolena.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Nyní můžete přijímat e-maily na vaši vlastní doménu."
      },
      "PHONE": {
        "TITLE": "Nastavení ústředny",
        "NOTE": "Nastavení ústředny pro telefonní hovory",
        "SIP_HOST": {
          "LABEL": "SIP doména"
        },
        "DIALING_MODE": {
          "LABEL": "Režim vytáčení",
          "MODES": {
            "direct": "Přímý - hovor se okamžitě vytočí při kliknutí na telefonní odkaz",
            "indirect": "Nepřímý - telefonní číslo se připraví v poli k vytočení"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Přístup k nahrávkám hovorů",
          "MODES": {
            "admin_only": "Pouze administrátoři",
            "admin_and_assigned_agent": "Administrátoři a přiřazený agent",
            "inbox_members": "Vsichni agenti s přístupem do schránky"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Nastavení e-mailu",
        "NOTE": "Upraví chování emalových shránek"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Zobrazení časových razítek v seznamu konverzací",
        "MODES": {
          "both": "Vytvořeno a poslední aktivita",
          "last_activity_only": "Poslední aktivita",
          "last_customer_message": "Poslední zpráva od zákazníka"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokovat domény s nízkou reputací"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Zahrnout v odpovědi na email předchozí zprávu"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automaticky vyřešit novou konverzaci"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automaticky přesunout novou e-mailovou konverzaci do schránky robota, který zpracoval objednávky kontaktu"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Rozšířené štítky - Povolit delší názvy štítků s větším vyskakovacím oknem"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Automaticky přiřadit konverzaci agentovi, který vytvořil poslední odpověď"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Režim push notifikací",
        "MODES": {
          "all_inboxes": "Všechny schránky - Posílat notifikace pro všechny typy kanálů",
          "chat_only": "Pouze chat - Posílat notifikace pouze pro ne-emailové kanály"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Povolit vypnutí podpisu u odeslaných zpráv"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Zobrazovat stav agenta v chatu na wallboardu"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Zobrazovat úplné názvy příloh bez zkrácení"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Přihlášení heslem",
        "MODES": {
          "allowed_for_all": "Povoleno pro všechny",
          "allowed_for_agents_only": "Povoleno pouze pro agenty (administrátoři musí použít OAuth)",
          "password_login_disabled": "Zakázáno - pouze přes OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Je k dispozici nová verze. Obnovte stránku pro získání nejnovějších aktualizací.",
    "RELOAD_NOW": "Aktualizovat",
    "LEARN_MORE": "Zjistit více",
    "PAYMENT_PENDING": "Vaše platba čeká na vyřízení. Aktualizujte prosím své platební údaje, abyste mohli nadále používat kontaktní centrum",
    "LIMITS_UPGRADE": "Váš účet překročil limity používání, upgradujte prosím svůj plán, abyste mohli nadále používat kontaktní centrum",
    "OPEN_BILLING": "Otevřít fakturaci"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Stiskněte Enter pro vybrání",
      "ENTER_TO_REMOVE": "Stiskněte Enter pro odebrání",
      "NO_OPTIONS": "Seznam je prázdný",
      "NO_RESULT": "Nebyly nalezeny žádné výsledky",
      "SELECT_ONE": "Vyberte jeden",
      "SELECT": "Vybrat"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Oznámení",
    "MARK_ALL_DONE": "Označit vše dokončeno",
    "DELETE_TITLE": "smazáno",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nepřečtená oznámení",
      "ALL_NOTIFICATIONS": "Zobrazit všechna oznámení",
      "LOADING_UNREAD_MESSAGE": "Načítání nepřečtených oznámení...",
      "EMPTY_MESSAGE": "Nemáte žádná nepřečtená oznámení"
    },
    "LIST": {
      "LOADING_MESSAGE": "Načítání upozornění...",
      "404": "Žádná upozornění",
      "TABLE_HEADER": [
        "Název",
        "Telefonní číslo",
        "Konverzace",
        "Naposledy kontaktováno"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nová konverzace",
      "conversation_assignment": "Přiřazená konverzace",
      "assigned_conversation_new_message": "Nová zpráva",
      "participating_conversation_new_message": "Nová zpráva",
      "conversation_mention": "Zmínka",
      "sla_missed_first_response": "SLA zmeškáno",
      "sla_missed_next_response": "SLA zmeškáno",
      "sla_missed_resolution": "SLA zmeškáno"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Znovu se připojuji...",
      "RECONNECT_SUCCESS": "Znovu připojeno"
    },
    "BUTTON": {
      "REFRESH": "Obnovit"
    },
    "CONNECTION_LOST": {
      "TITLE": "Připojení ztraceno",
      "DESCRIPTION": "Nepodařilo se nám spojit se serverem. Zkontrolujte připojení a zkuste to znovu.",
      "RETRY": "Zkusit znovu"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Hledat nebo přejít na",
    "SECTIONS": {
      "GENERAL": "Obecné",
      "REPORTS": "Reporty",
      "CONVERSATION": "Konverzace",
      "BULK_ACTIONS": "Hromadné akce",
      "CHANGE_ASSIGNEE": "Změnit přiřazeného agenta",
      "CHANGE_PRIORITY": "Změnit prioritu",
      "CHANGE_TEAM": "Změnit tým",
      "SNOOZE_CONVERSATION": "Odložit konverzaci",
      "EXECUTE_MACRO": "Spustit makro",
      "ADD_LABEL": "Přidat štítek ke konverzaci",
      "REMOVE_LABEL": "Odebrat štítek z konverzace",
      "SETTINGS": "Nastavení",
      "AI_ASSIST": "AI asistent",
      "APPEARANCE": "Vzhled",
      "SNOOZE_NOTIFICATION": "Odložit oznámení"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Přejít na nástěnku konverzací",
      "GO_TO_CONTACTS_DASHBOARD": "Přejít na nástěnku kontaktů",
      "GO_TO_REPORTS_OVERVIEW": "Přejít na přehled reportů",
      "GO_TO_CONVERSATION_REPORTS": "Přejít na reporty konverzací",
      "GO_TO_AGENT_REPORTS": "Přejít na reporty agentů",
      "GO_TO_LABEL_REPORTS": "Přejít na reporty štítků",
      "GO_TO_INBOX_REPORTS": "Přejít na reporty schránek",
      "GO_TO_TEAM_REPORTS": "Přejít na reporty týmů",
      "GO_TO_SETTINGS_AGENTS": "Přejít na nastavení agentů",
      "GO_TO_SETTINGS_TEAMS": "Přejít na nastavení týmů",
      "GO_TO_SETTINGS_INBOXES": "Přejít na nastavení schránek",
      "GO_TO_SETTINGS_LABELS": "Přejít na nastavení štítků",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Přejít na nastavení předpřipravených odpovědí",
      "GO_TO_SETTINGS_APPLICATIONS": "Přejít na nastavení aplikací",
      "GO_TO_SETTINGS_ACCOUNT": "Přejít na nastavení účtu",
      "GO_TO_SETTINGS_PROFILE": "Přejít na nastavení profilu",
      "GO_TO_NOTIFICATIONS": "Přejít na oznámení",
      "ADD_LABELS_TO_CONVERSATION": "Přidat štítek ke konverzaci",
      "ASSIGN_AN_AGENT": "Přiřadit agenta",
      "AI_ASSIST": "AI asistent",
      "ASSIGN_PRIORITY": "Přiřadit prioritu",
      "ASSIGN_A_TEAM": "Přiřadit tým",
      "EXECUTE_A_MACRO": "Spustit makro",
      "MUTE_CONVERSATION": "Ztlumit konverzaci",
      "UNMUTE_CONVERSATION": "Zrušit ztlumení konverzace",
      "REMOVE_LABEL_FROM_CONVERSATION": "Odebrat štítek z konverzace",
      "REOPEN_CONVERSATION": "Znovu otevřít konverzaci",
      "RESOLVE_CONVERSATION": "Vyřešit konverzaci",
      "SEND_TRANSCRIPT": "Poslat e-mailový přepis",
      "SNOOZE_CONVERSATION": "Odložit konverzaci",
      "UNTIL_NEXT_REPLY": "Do další odpovědi",
      "UNTIL_NEXT_WEEK": "Do příštího týdne",
      "UNTIL_TOMORROW": "Do zítřka",
      "UNTIL_NEXT_MONTH": "Do příštího měsíce",
      "AN_HOUR_FROM_NOW": "Za hodinu",
      "UNTIL_CUSTOM_TIME": "Vlastní...",
      "CHANGE_APPEARANCE": "Změnit vzhled",
      "LIGHT_MODE": "Světlý",
      "DARK_MODE": "Tmavý",
      "SYSTEM_MODE": "Systémový",
      "SNOOZE_NOTIFICATION": "Odložit oznámení"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Načítání nástěnkové aplikace..."
  },
  "COMMON": {
    "OR": "Nebo",
    "CLICK_HERE": "klikněte zde"
  }
}